// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__UFnij","productName":"Table_productName__wPo9O"};